export var SpecialTariffType;
(function (SpecialTariffType) {
  SpecialTariffType["YandexPlus"] = "YandexPlus";
  SpecialTariffType["TariffUp"] = "TariffUp";
  SpecialTariffType["SvyazZ"] = "SvyazZ";
  SpecialTariffType["Constructor"] = "Constructor";
  SpecialTariffType["OldConstructor"] = "OldConstructor";
  SpecialTariffType["Prostoy"] = "Prostoy";
  SpecialTariffType["PlanB"] = "PlanB";
})(SpecialTariffType || (SpecialTariffType = {}));
export var MobileUserEnum;
(function (MobileUserEnum) {
  MobileUserEnum["Mobile"] = "mobile";
  MobileUserEnum["Business"] = "business";
})(MobileUserEnum || (MobileUserEnum = {}));
export var ModalStatus;
(function (ModalStatus) {
  ModalStatus["USER_ACTIVE"] = "userActiveFirstPopupText";
  ModalStatus["SOCIAL_INTERNET"] = "socialInternet";
  ModalStatus["USER_FINANCIAL_BLOCKING"] = "finBlockedPopupTexts";
  ModalStatus["USER_IS_VOLUNTARY_BLOCKING"] = "selfBlockedPopupTexts";
  ModalStatus["SUCCESS"] = "connectSuccessfulPopupTexts";
  ModalStatus["NO_MONEY"] = "notEnoughMoneyPopupTexts";
  ModalStatus["NO_ROUTER_MONEY"] = "notEnoughMoneyPopupRouterTexts";
  ModalStatus["DISCONNECT_CONFIRM"] = "disconnectPopupTexts";
  ModalStatus["DISCONNECT_SUCCESS"] = "disconnectSuccessfulPopupTexts";
  ModalStatus["IN_PROCESSING"] = "requestAcceptedPopupTexts";
  ModalStatus["ESIA"] = "esiaAuthPopupTexts";
  ModalStatus["OTHER_BLOCKING"] = "otherBlockedPopupTexts";
  ModalStatus["ESIA_FAIL"] = "esiaFailPopupTexts";
  ModalStatus["NOT_ACCESS"] = "notAccessPopupTexts";
  ModalStatus["CITIZEN_SHIP_ERROR"] = "citizenshipErrorPopupTexts";
  ModalStatus["NOT_VERIFY_ACCOUNT"] = "notVerifyAccountPopupTexts";
  ModalStatus["PERSONAL_DATA_ERROR"] = "personalDataErrorPopupTexts";
  ModalStatus["NOT_ENOUGH_DATA"] = "notEnoughDataErrorPopupTexts";
  ModalStatus["SOCIAL_INTERNET_SUCCESS"] = "socialInternetSuccessfulPopupTexts";
  ModalStatus["BLOCKING_ERROR"] = "blockingErrorPopupTexts";
  ModalStatus["NO_ANSWER"] = "failPopupTexts";
  ModalStatus["IS_OPEN_MODAL"] = "isOpenModal";
  ModalStatus["ROUTER_REDEMPTION"] = "routerRedemption";
  ModalStatus["ROUTER_MANAGE"] = "routerManage";
  ModalStatus["ROUTER_MANAGE_MOBILE"] = "routerManageMobile";
  ModalStatus["APPLICATION_SENT"] = "applicationSentPopupTexts";
  ModalStatus["NO_DEVICES_AVAILABLE"] = "noDevicesAvailable";
  ModalStatus["APPLICATION_PROBLEM_POPUP_TEXTS"] = "applicationProblemPopupTexts";
  ModalStatus["SUCCESS_POPUP_TEXTS"] = "successPopupTexts";
  ModalStatus["SUBMIT_APPLICATION_POPUP_TEXTS"] = "submitApplicationPopupTexts";
  ModalStatus["TV_CHANNELS_POPUP"] = "tvChannelsPopup";
  ModalStatus["AVAILABLE_TO_RENT_POPUP_TEXTS"] = "availableToRentPopupTexts";
  ModalStatus["CHARACTERISTICS_POPUP_TEXTS"] = "characteristicsPopUpTexts";
  ModalStatus["PROMISED_PAYMENT"] = "promisedPayment";
  ModalStatus["PROMISED_PAYMENT_SUCCESS"] = "connectPromisedPaymentSuccess";
  ModalStatus["PROMISED_PAYMENT_PLANNED"] = "promisedPaymentIsPlannedPopupTexts";
  ModalStatus["CAPTCHA"] = "captcha";
  ModalStatus["MOVEMENT_BANNER"] = "movementBanner";
  ModalStatus["APPROVE_REQUEST"] = "approveRequest";
  ModalStatus["SPEED_LIMIT"] = "speedLimit";
  ModalStatus["HAS_FAST_INTERNET"] = "hasFastInternet";
  ModalStatus["CONTRACT_BLOCKED"] = "contractBlocked";
  ModalStatus["SOMETHING_WRONG"] = "somethingWrong";
  ModalStatus["BLOCK_AGREEMENT_QUESTION"] = "blockAgreementQuestion";
  ModalStatus["BLOCK_AGREEMENT_CALENDAR"] = "blockAgreementCalendar";
  ModalStatus["PLANNING_BLOCKING_QUESTION"] = "planningBlockingQuestion";
  ModalStatus["BLOCKING_IS_PLANNED"] = "blockingIsPlanned";
  ModalStatus["BLOCKING_IS_NOT_AVAILABLE"] = "blockingIsNotAvailable";
  ModalStatus["BLOCKING_SETTINGS"] = "blockingSettings";
  ModalStatus["BLOCKING_CANCELED"] = "blockingCanceled";
  ModalStatus["DATA_BLOCKED_CHANGED"] = "dataBlockedChanged";
  ModalStatus["AGREEMENT_IS_UN_BLOCKED"] = "agreementIsUnBlocked";
})(ModalStatus || (ModalStatus = {}));